const cache = new Map();
export default function loadScriptOrStyle(type, src, prefix, attrs) {
  if (Array.isArray(src)) {
    return Promise.all(src.map(item => loadScriptOrStyle(type, item, prefix)));
  }
  const fixedSrc = prefix && !/^https?:/.test(src) ? `${prefix}${src}` : src;
  const cachedPromise = cache.get(fixedSrc);
  if (cachedPromise) {
    return cachedPromise;
  }
  const promise = new Promise((resolve, reject) => {
    const end = () => {
      window.dispatchEvent(new Event("request.end"));
    };
    const element = document.createElement(type === "style" ? "link" : "script");
    if (type === "script") {
      Object.assign(element, {
        type: "text/javascript",
        async: true,
        ...attrs,
        src: fixedSrc
      });
    } else {
      Object.assign(element, {
        rel: "stylesheet",
        ...attrs,
        href: fixedSrc
      });
    }
    element.onload = () => {
      resolve(fixedSrc);
      end();
    };
    element.onerror = e => {
      reject(e);
      end();
    };
    const firstScript = document.currentScript || document.getElementsByTagName("script")[0];
    firstScript.parentNode.insertBefore(element, firstScript);
    window.dispatchEvent(new Event("request.start"));
  });
  cache.set(fixedSrc, promise);
  return promise;
}
//# sourceMappingURL=loadScriptOrStyle.js.map